import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-bt_004_d",
  "use": "icon-bt_004_d-usage",
  "viewBox": "0 0 67 33",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 67 33\" id=\"icon-bt_004_d\"><defs><style>#icon-bt_004_d .cls-1{fill:none;opacity:0;}#icon-bt_004_d .cls-2{fill:#aaa;}</style></defs><g id=\"icon-bt_004_d_レイヤー_2\" data-name=\"レイヤー 2\"><g id=\"icon-bt_004_d_icon\"><path class=\"cls-1\" d=\"M67,33H0V0H67V33Z\" /><path class=\"cls-2\" d=\"M64,2V30H2V2H64m1-1H1V31H65V1Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol